import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=798100fe&scoped=true"
import script from "./ModalWrapper.vue?vue&type=script&lang=js"
export * from "./ModalWrapper.vue?vue&type=script&lang=js"
import style0 from "./ModalWrapper.vue?vue&type=style&index=0&id=798100fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798100fe",
  null
  
)

/* custom blocks */
import block0 from "./ModalWrapper.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports